import React from 'react';

const EmptyTableCell = () => (<i className="fal fa-dash" />);

export default EmptyTableCell;
